module.exports = __webpack_public_path__ + "static/fonts/proximasoftlight-webfont.38ea66e.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/proximasoftlight-webfont.ttf
// module id = 1024
// module chunks = 11